import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker } from "react-icons/hi";
import { Reveal } from "./ui";

export default function ContactCTA() {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    emailjs
      .sendForm("service_58jl8rh", "template_lnkxw49", form.current, "WZ8UBSqUYOkPtkkuy")
      .then(
        () => {
          setStatus({ ok: true, text: "Thank you. A senior Chiparama lead will review your brief and respond." });
          setLoading(false);
          form.current.reset();
        },
        () => {
          setStatus({ ok: false, text: "We couldn't send your message. Please try again or email contact@chiparama.com." });
          setLoading(false);
        }
      );
  };

  return (
    <section id="contact" className="on-dark noise section relative overflow-hidden bg-navy-950 text-white">
      <div className="bg-grid-dark absolute inset-0 [mask-image:radial-gradient(ellipse_at_20%_20%,black,transparent_70%)]" aria-hidden="true" />
      <div className="glow-blue absolute -right-32 top-10 h-[36rem] w-[36rem] animate-drift opacity-50" aria-hidden="true" />
      <div className="glow-teal absolute -left-40 bottom-0 h-[30rem] w-[30rem] opacity-30" aria-hidden="true" />

      <div className="container-x relative grid items-start gap-16 lg:grid-cols-[1.1fr_0.9fr] lg:gap-24">
        <div>
          <p className="eyebrow mb-6 flex items-center gap-3">
            <span className="text-white/40">07</span>
            <span className="h-px w-8 bg-white/25" aria-hidden="true" />
            Start a conversation
          </p>
          <h2 className="h-display">
            Bring us the milestone <span className="text-gradient">that is at risk.</span>
          </h2>
          <p className="lede mt-7 max-w-xl">
            Tell us the domain, stage and delivery need. A senior Chiparama lead will respond with the
            right next step—not a generic sales sequence.
          </p>
          <ul className="mt-12 space-y-5 text-slate-300">
            {[
              { icon: HiOutlineMail, node: <a href="mailto:contact@chiparama.com" className="hover:text-white">contact@chiparama.com</a> },
              { icon: HiOutlinePhone, node: <a href="tel:+14085948864" className="hover:text-white">+1 (408) 594-8864</a> },
              { icon: HiOutlineLocationMarker, node: <span>10605 Jonwood Way, Austin, TX 78753, USA</span> },
            ].map(({ icon: Icon, node }, i) => (
              <li key={i} className="flex items-center gap-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/15 bg-white/[0.04]">
                  <Icon className="h-5 w-5 text-brand-light" aria-hidden="true" />
                </span>
                {node}
              </li>
            ))}
          </ul>
        </div>

        <Reveal>
          <form
            ref={form}
            onSubmit={sendEmail}
            className="rounded-3xl border border-white/15 bg-white p-8 text-ink shadow-[0_40px_100px_-30px_rgba(36,87,245,0.6)] md:p-10"
          >
            <h3 className="font-display text-2xl font-semibold tracking-tight">Send an engineering brief</h3>
            <div className="mt-7 space-y-5">
              <div>
                <label htmlFor="home_user_name" className="field-label">Your name</label>
                <input id="home_user_name" name="user_name" type="text" required className="field" placeholder="Jane Smith" autoComplete="name" />
              </div>
              <div>
                <label htmlFor="home_user_email" className="field-label">Work email</label>
                <input id="home_user_email" name="user_email" type="email" required className="field" placeholder="you@company.com" autoComplete="email" />
              </div>
              <div>
                <label htmlFor="home_message" className="field-label">Program overview</label>
                <textarea id="home_message" name="message" rows="5" required className="field" placeholder="Domain, stage and delivery need. Please do not include confidential or export-controlled information." />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full py-4 text-base">
                {loading ? "Sending..." : "Discuss your program"}
              </button>
              {status && (
                <p role="status" className={`text-sm ${status.ok ? "text-emerald-700" : "text-red-600"}`}>{status.text}</p>
              )}
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
